import { Controller } from "@hotwired/stimulus"

/**
 * Table Controller
 * 테이블 컴포넌트의 상태 관리 및 인터랙션 처리
 */
export default class extends Controller {
  static targets = ["content", "toolbar", "pagination", "pageInfo", "searchInput"]

  static values = {
    totalCount: { type: Number, default: 0 },
    currentPage: { type: Number, default: 1 },
    perPage: { type: Number, default: 10 },
    totalPages: { type: Number, default: 1 }
  }

  connect() {
    // 테이블 초기화
  }

  // 검색 입력 시 디바운스 처리
  search(event) {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => {
      event.target.form.requestSubmit()
    }, 300)
  }

  // 검색어 초기화
  clearSearch() {
    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = ""
      this.searchInputTarget.form.requestSubmit()
    }
  }

  // 페이지 변경
  goToPage(event) {
    const page = event.currentTarget.dataset.page
    if (page) {
      this.currentPageValue = parseInt(page)
      // URL 업데이트는 링크로 처리
    }
  }

  // 페이지 크기 변경
  changePerPage(event) {
    const perPage = event.target.value
    if (perPage) {
      this.perPageValue = parseInt(perPage)
      // 폼 자동 제출 (auto-submit 컨트롤러에서 처리)
    }
  }
}
